module.exports = __webpack_public_path__ + "static/img/logo2.42b1ff9e.png";